import React, { useState } from "react";
import styled from "styled-components";
import Page from "../components/Page";
import { useLang } from "../i18n/LanguageContext";
import usePageMeta from "../hooks/usePageMeta";

const DATA = {
  sq: [
    { q: "A është falas për çiftet?", a: "Po. Kërkimi, ruajtja dhe kontaktimi i bizneseve është plotësisht falas për çiftet. Nuk ke nevojë as për llogari." },
    { q: "Si e kontaktoj një biznes?", a: "Çdo biznes ka butona për telefon, WhatsApp dhe Instagram. Klikon dhe flet drejtpërdrejt me ta — pa ndërmjetës." },
    { q: "Si i ruaj bizneset që më pëlqejnë?", a: "Kliko zemrën te çdo biznes. Lista jote ruhet automatikisht në këtë pajisje dhe e gjen te faqja 'Të ruajtura'." },
    { q: "Si e regjistroj biznesin tim?", a: "Shko te 'Regjistro biznesin', plotëso formularin në disa hapa, zgjidh planin dhe dërgo. Ne e shqyrtojmë dhe të aktivizojmë pas konfirmimit të pagesës." },
    { q: "Sa kushton për bizneset?", a: "Ofrojmë dy plane, Bazik dhe Premium, me çmime mujore që ndryshojnë sipas kategorisë. Çmimin e saktë e sheh te hapi i fundit i regjistrimit." },
    { q: "Si paguaj?", a: "Pagesa bëhet drejtpërdrejt me ne (bankë ose para në dorë). Sapo konfirmohet, biznesi yt aktivizohet në platformë." },
    { q: "Sa zgjat derisa të dal online?", a: "Zakonisht brenda 24 orëve pas konfirmimit të pagesës. Merr një njoftim kur listimi yt është aktiv." },
    { q: "Cili është ndryshimi mes Bazik dhe Premium?", a: "Premium të jep më shumë foto, përshkrim më të gjatë, video, ueb-faqe, Instagram, pozicion mbi bizneset bazike, statistika dhe ditë promovimi falas çdo muaj." },
    { q: "Çfarë është një promovim (boost)?", a: "Një promovim e ngjit biznesin tënd në krye të listës për një numër ditësh që ti zgjedh. Vendet janë të kufizuara, prandaj funksionon si reklamë me përparësi." },
    { q: "A mund ta ndryshoj listimin tim?", a: "Po. Hyr te 'Menaxho biznesin' dhe përditëso fotot, përshkrimin dhe detajet kurdoherë." },
  ],
  en: [
    { q: "Is it free for couples?", a: "Yes. Browsing, saving and contacting businesses is completely free for couples. You don't even need an account." },
    { q: "How do I contact a business?", a: "Every business has call, WhatsApp and Instagram buttons. You tap and talk to them directly — no middleman." },
    { q: "How do I save the businesses I like?", a: "Tap the heart on any business. Your list is saved automatically on this device and lives on the 'Saved' page." },
    { q: "How do I list my business?", a: "Go to 'List your business', fill out the short multi-step form, choose a plan and submit. We review it and activate you once payment is confirmed." },
    { q: "How much does it cost for businesses?", a: "We offer two plans, Basic and Premium, with monthly prices that vary by category. You see the exact price at the final step of registration." },
    { q: "How do I pay?", a: "Payment is made directly with us (bank transfer or cash). Once confirmed, your business goes live on the platform." },
    { q: "How long until I'm online?", a: "Usually within 24 hours of payment confirmation. You'll get a notification when your listing is active." },
    { q: "What's the difference between Basic and Premium?", a: "Premium gives you more photos, a longer description, video, website, Instagram, placement above Basic listings, stats, and free boost days every month." },
    { q: "What is a boost?", a: "A boost pushes your business to the top of the list for a number of days you choose. Spots are limited, so it works like priority advertising." },
    { q: "Can I edit my listing?", a: "Yes. Log in to 'Manage your business' and update your photos, description and details anytime." },
  ],
};

export default function Faq() {
  const { lang } = useLang();
  const sq = lang === "sq";
  usePageMeta(sq ? "Pyetjet e shpeshta — Amora Weddings" : "FAQ — Amora Weddings");
  const [open, setOpen] = useState(0);
  const items = DATA[sq ? "sq" : "en"];

  return (
    <Page title={sq ? "Pyetjet e shpeshta" : "Frequently asked questions"} narrow>
      <List>
        {items.map((it, i) => (
          <Item key={i} $open={open === i}>
            <button onClick={() => setOpen(open === i ? -1 : i)}>
              <span>{it.q}</span>
              <i>{open === i ? "–" : "+"}</i>
            </button>
            {open === i && <p>{it.a}</p>}
          </Item>
        ))}
      </List>
    </Page>
  );
}

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Item = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.hair};
  border-radius: 14px;
  background: ${({ $open, theme }) => ($open ? theme.colors.surface : "transparent")};
  overflow: hidden;
  button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    background: transparent;
    border: none;
    cursor: pointer;
    text-align: left;
    padding: 18px 20px;
    font-family: inherit;
    font-size: 16px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.ink};
  }
  i { font-style: normal; font-size: 22px; color: ${({ theme }) => theme.colors.green}; line-height: 1; }
  p { padding: 0 20px 20px; color: ${({ theme }) => theme.colors.inkSoft}; font-size: 15px; line-height: 1.65; }
`;
